import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { GradientWiseDropTableComponent } from './gradient-wise-drop-table.component';



@NgModule({
  declarations: [GradientWiseDropTableComponent],
  imports: [
    CommonModule,
     FormsModule,
        ReactiveFormsModule,
            CustomDropdownModule,
            CustomDatePickerModule,
            MaterialModule,
            CustomTimpickerModule,
            CustomInputModule,
            MatPaginatorModule,
            ExpansionPanelModule,
  ],exports: [GradientWiseDropTableComponent],
})
export class GradientWiseDropTableModule { }
